module.exports = __webpack_public_path__ + "img/lx.1c884d27.svg";